// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useEffect, useState } from "react"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CONSTANT from "../../../constant"
import dateUtil from "../../../ts/util/dateUtil"

export type T勤怠集計 = {
  勤務時間: string
  残業時間: string
  休出時間: string
  深夜時間: string
  拘束時間: string
}

const SummaryTimeGrid: React.FC<{
  kintaiSummaryData: T勤怠集計[]
  isRestoreSearching: boolean
  setIsRestoreSearching: React.Dispatch<React.SetStateAction<boolean>>
}> = (props) => {
  let summaryCountGridId = "zyomuinSyukkinbo_SummaryCountGridId"

  const [summaryCountFlexGrid, setSummaryCountFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [summaryCountGridInitialized, setSummaryCountGridInitialized] = useState<boolean>(false)

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: T勤怠集計[]) => {
    return new wjCore.CollectionView(data, {
      calculatedFields: {},
    })
  }

  const [gridData, setGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionView([]),
  })

  // グリッド初期化時イベントハンドラ
  const SummaryTImeGridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      switch (c.binding as keyof T勤怠集計) {
        case "勤務時間":
        case "残業時間":
        case "休出時間":
        case "深夜時間":
        case "拘束時間":
          columnHeaders.setCellData(0, index, "就労時間")
          break
      }
      c.allowMerging = true
      c.align = "center"
    })

    // ヘッダの設定
    grid.formatItem.addHandler(summaryFormatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const summaryFormatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (f.cells === e.panel) {
      const col = e.getColumn()
      const data = f.getCellData(e.row, e.col, false)
      switch (col.binding as keyof T勤怠集計) {
        case "残業時間":
          const colMilliSecond = dateUtil.toMilliseconds(data)
          const hour60 = 60 * 60 * 60 * 1000
          const hour80 = 80 * 60 * 60 * 1000

          wjCore.toggleClass(e.cell, "bg-amber", hour60 <= colMilliSecond && colMilliSecond < hour80)
          wjCore.toggleClass(e.cell, "bg-red", hour80 <= colMilliSecond)
          break
      }
    }
  }

  useEffect(() => {
    setGridData({ data: createCollectionView(props.kintaiSummaryData) })
  }, [props.kintaiSummaryData])

  return (
    <FlexGridOuter
      flexGrid={summaryCountFlexGrid}
      setFlexGrid={setSummaryCountFlexGrid}
      gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_TOTAL}
      gridData={gridData}
      setGridData={setGridData}
      pageNumber={1}
      gridId={summaryCountGridId}
      isRestoreSearching={props.isRestoreSearching}
      setIsRestoreSearching={props.setIsRestoreSearching}
      gridInitialized={summaryCountGridInitialized}
      setGridInitialized={setSummaryCountGridInitialized}
      isShowGridHeader={false}
      isShowGridFooter={false}
      pageSize={0}
      setPageSize={() => {}}
      style={{ maxHeight: "Auto" }}
      gridInitializedHandler={SummaryTImeGridInitializedHandler}
      isShowGridRowPickupButton={false}
      gridProperties={{
        stickyHeaders: false,
      }}
      hasFilter={false}>
      <wjrGrid.FlexGridColumn
        binding="勤務時間"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={70}
        header="勤務"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="残業時間"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={70}
        header="残業"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="深夜時間"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={70}
        header="深夜"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="休出時間"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={70}
        header="休出"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="拘束時間"
        isRequired={false}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        width={70}
        header="拘束"></wjrGrid.FlexGridColumn>
    </FlexGridOuter>
  )
}

export default SummaryTimeGrid
